export default class Gtm {
  construct(logging) {
    this.loggingEnabled = logging ?? false
  }

  homepageCTA() {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'cta_click',
      cta: 'home_page_cta',
    })

    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'cta_click',
        cta: 'home_page_cta',
      })
  }

  sliderClick(cta_text, banner_title) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'banner_click',
      cta_text,
      banner_title,
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'banner_click',
        cta_text,
        banner_title,
      })
  }

  emailSubscription(notification_signup_location) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'email_signup',
      notification_signup_location, // {{location}} //e.g. 'Footer, checkout, account registration, promotion, etc'
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'email_signup',
        notification_signup_location, // {{location}} //e.g. 'Footer, checkout, account registration, promotion, etc'
      })
  }

  socialMediaClick(social_network) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'select_social',
      social_network, //{{social network}} //ex: facebook, twitter, instagram, youtube
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'select_social',
        social_network, //{{social network}} //ex: facebook, twitter, instagram, youtube
      })
  }

  contentTilesClick(section, title) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'select_content',
      content_type: section, // {{tile section}}, //e.g. 'our partners' / 'top locations'
      tile_text: title, // {{click text}}
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'select_content',
        content_type: section, // {{tile section}}, //e.g. 'our partners' / 'top locations'
        tile_text: title, // {{click text}}
      })
  }

  formErrorDisplay(type, message) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'form_error',
      error_type: type, // {{error type}} //eg. 'reservation form,
      error_message: message, // {{banner title}} // Error message that was generated
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'form_error',
        error_type: type, // {{error type}} //eg. 'reservation form,
        error_message: message, // {{banner title}} // Error message that was generated
      })
  }

  errorDisplay(type, message) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'error',
      error_type: type, // {{error type}} //eg. 'reservation form,
      error_message: message, // {{banner title}} // Error message that was generated
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'error',
        error_type: type, // {{error type}} //eg. 'reservation form,
        error_message: message, // {{banner title}} // Error message that was generated
      })
  }

  cancelBooking(bookingDetails) {
    dataLayer.push({
      ecommerce: {
        //ecommerce data
        refund: {
          actionField: {
            id: bookingDetails.VehSegmentCore.ConfID['@attributes'].ID,
          },
        },
      },
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        ecommerce: {
          //ecommerce data
          refund: {
            actionField: {
              id: bookingDetails.VehSegmentCore.ConfID['@attributes'].ID,
            },
          },
        },
      })
  }

  startSearch(data) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
    if (this.loggingEnabled) console.log('GTM EVENT:', data)
  }

  searchImpression(impressions) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        impressions,
      },
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'view_item_list',
        ecommerce: {
          impressions,
        },
      })
  }

  carDetails(product) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currencyCode: window.location.hostname.includes('.co.nz') ? 'NZD' : 'AUD',
        detail: {
          actionField: { list: 'vehicle list' },
          products: [product],
        },
      },
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'view_item',
        ecommerce: {
          currencyCode: window.location.hostname.includes('.co.nz') ? 'NZD' : 'AUD',
          detail: {
            actionField: { list: 'vehicle list' },
            products: [product],
          },
        },
      })
  }

  addToCart(product, quantity, position) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currencyCode: window.location.hostname.includes('.co.nz') ? 'NZD' : 'AUD',
        add: {
          products: [{ ...product, quantity }],
        },
      },
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'add_to_cart',
        ecommerce: {
          currencyCode: window.location.hostname.includes('.co.nz') ? 'NZD' : 'AUD',
          add: {
            products: [{ ...product, quantity }],
          },
        },
      })

    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'select_item',
      ecommerce: {
        click: {
          actionField: { list: 'vehicle list' },
          products: [
            {
              ...product,
              position,
            },
          ],
        },
      },
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'select_item',
        ecommerce: {
          click: {
            actionField: { list: 'vehicle list' },
            products: [
              {
                ...product,
                position,
              },
            ],
          },
        },
      })
  }

  addToCartAddon(product, quantity, position) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currencyCode: window.location.hostname.includes('.co.nz') ? 'NZD' : 'AUD',
        add: {
          products: [{ ...product, quantity }],
        },
      },
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'add_to_cart',
        ecommerce: {
          currencyCode: window.location.hostname.includes('.co.nz') ? 'NZD' : 'AUD',
          add: {
            products: [{ ...product, quantity }],
          },
        },
      })

    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'select_item',
      ecommerce: {
        click: {
          actionField: { list: 'add on list' },
          products: [
            {
              ...product,
              position,
            },
          ],
        },
      },
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'select_item',
        ecommerce: {
          click: {
            actionField: { list: 'add on list' },
            products: [
              {
                ...product,
                position,
              },
            ],
          },
        },
      })
  }

  removeFromCartAddon(product, quantity) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currencyCode: window.location.hostname.includes('.co.nz') ? 'NZD' : 'AUD',
        remove: {
          products: [{ ...product, quantity }],
        },
      },
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'remove_from_cart',
        ecommerce: {
          currencyCode: window.location.hostname.includes('.co.nz') ? 'NZD' : 'AUD',
          remove: {
            products: [{ ...product, quantity }],
          },
        },
      })
  }

  checkoutPage(data) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'add_payment_info',
      step_name: '2 - Information and book page',
      ecommerce: {
        checkout: {
          actionField: { step: 3 },
          products: [data],
        },
      },
    })
    if (this.loggingEnabled)
      console.log('GTM EVENT:', {
        event: 'add_payment_info',
        step_name: '2 - Information and book page',
        ecommerce: {
          checkout: {
            actionField: { step: 3 },
            products: [data],
          },
        },
      })
  }

  confirmBooking(currentTrip, mode, selectedVehicle) {
    const duration =
      (new Date(currentTrip.until).getTime() - new Date(currentTrip.from).getTime()) / 86400000
    const durationInteger = Math.round(duration) < 1 ? 1 : Math.round(duration)
    const car = _.find(currentTrip.rates[mode], { Class: currentTrip.car })

    if (this.loggingEnabled) console.log(currentTrip)

    const eventPayload = {
      event: 'purchase',
      ecommerce: {
        transaction_id: currentTrip.res,
        value: Number(currentTrip.payment.Transaction.Amount),
        tax:
          Number(
            currentTrip.estimate?.Charge?.find(
              chargeitem => chargeitem['@attributes'].desc == 'GST',
            )['@attributes'].total,
          ) || 0,
        shipping: 0,
        currency: currentTrip.estimate?.['@attributes'].currencyCode,
        items: [
          {
            item_brand: currentTrip.searchType,
            item_category:
              car.fullDetails.VehAvailCore.Vehicle.VehType['@attributes'].VehicleCategory,
            item_id: currentTrip.car,
            item_name: `(${currentTrip.car.substring(0, 1)}) ${selectedVehicle.vehicle_model}`,
            item_variant: `${car.fullDetails.VehAvailCore.Vehicle.VehClass['@attributes'].Size} doors`,
            price: Number(currentTrip.payment.Transaction.Amount),
            quantity: durationInteger,
          },
        ],
      },
      transactionId: currentTrip.res,
      transactionAffiliation: 'pay later',
      transactionTotal: Number(currentTrip.payment.Transaction.Amount),
      transactionTax:
        Number(
          currentTrip.estimate?.Charge?.find(chargeitem => chargeitem['@attributes'].desc == 'GST')[
            '@attributes'
          ].total,
        ) || 0,
      transactionShipping: 0,
      transactionProducts: [
        {
          name: `(${currentTrip.car.substring(0, 1)}) ${selectedVehicle.vehicle_model}`,
          id: currentTrip.car,
          price: Number(currentTrip.payment.Transaction.Amount),
          brand: currentTrip.searchType,
          category: car.fullDetails.VehAvailCore.Vehicle.VehType['@attributes'].VehicleCategory,
          variant: `${car.fullDetails.VehAvailCore.Vehicle.VehClass['@attributes'].Size} doors`,
          quantity: durationInteger,
        },
      ],
    }

    dataLayer.push({ ecommerce: null })
    dataLayer.push(eventPayload)

    // dataLayer.push({ ecommerce: null });
    // dataLayer.push({
    //   event: 'purchase-new',
    //   ecommerce: ecommerceData,
    // })

    if (this.loggingEnabled) console.log('GTM EVENT:', eventPayload)
  }
}
